import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { userInfoLinkedBusinessAccountsCacheKey } from "./constants";
import type { DeleteUserInfoLinkedBusinessAccountParams } from "./types";

export const deleteUserInfoLinkedBusinessAccount = reactQueryMutationAdapter(
  [userInfoLinkedBusinessAccountsCacheKey],
  ({ userId, accountId }: DeleteUserInfoLinkedBusinessAccountParams): Promise<void> => {
    return fetch(
      `/apps/user_info_linked_business_accounts/${encodeURIComponent(userId)}`,
      "DELETE",
      { account_id: accountId },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
